import { dataFetched } from 'data/graphql'
import { aknowledgeThreadsActivity } from 'remote/activityRegistry'
import { SET_THREAD_DRAFT } from './actionTypes'

export const aknowledgeThreadActivity = (noteId, threadId) => ({
  dispatch,
  graphQLClient,
}) => {
  return {
    type: 'AKNOWLEDGE_THREADS_ACTIVITY',
    payload: graphQLClient
      .mutate({
        query: aknowledgeThreadsActivity,
        variables: {
          threadIds: [threadId],
          noteId,
        },
      })
      .then(({ data }) => {
        dispatch(dataFetched(data.aknowledgeThreadsActivity))
      }),
  }
}

export const setThreadDraft = ({ key, content }) => ({
  type: SET_THREAD_DRAFT,
  payload: { key, content },
})
